import * as React from "react";
const SvgHorizontalRule = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M4 11h16v2H4z",
  fill: "currentColor"
}));
export default SvgHorizontalRule;